module.exports = __webpack_public_path__ + "static/img/12.8579ddb2.png";